import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './components/main.css';

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import EnsureAnonymousUser from './components/AnynomousUser';
import { CartProvider } from './components/CartContext';
import CookieConsent from './components/CookieConsent';


// Import English Components
import Header from './components/Nav';
import Footer from './components/NewFooter';
import Home from './pages/Index';
import ProductDetail from './components/ProductDetails';
import CategoryList from './components/CategoryList';
import CategoryDetail from './components/CategoryDetails';
import ViewCart from './components/ViewCart';
import CheckoutForm from './components/CheckoutForm';
import Login from './components/Login';
import Register from './components/Register';
import SingleProduct from './components/SingleProduct';
import UserDash from './components/userDash';
import Cart from './components/Cart';
import OrderSummary from './components/OrderSummary';
import ReviewOrder from './components/ReviewOrder';
import PasswordReset from './components/ForgetPassword';
import PasswordResetConfirm from './components/PasswordReset';
import Products from './components/Products';
import NewCheckout from './components/NewCheckout';
import Legal from './components/Legal';
import About from './components/About';
import Impressum from './components/Impressum';
import PrivacyPolicy from './components/PrivacyPolicy';
import Contact from './components/Contact';
import Jobs from './components/Jobs';
import EventBooking from './components/EventBooking';

// Import German Components
import HeaderDe from './components/de/Nav';
import FooterDe from './components/de/NewFooter';
import Legalde from './components/de/Legalde';
import Aboutde from './components/de/Aboutde';
import ImpressumDe from './components/de/Impressum';
import HomeDe from './pages/IndexDe';
import ProductDetailDe from './components/de/ProductDetails';
import CategoryListDe from './components/de/CategoryList';
import CategoryDetailDe from './components/de/CategoryDetails';
import ViewCartDe from './components/de/ViewCart';
import LoginDe from './components/de/Login';
import RegisterDe from './components/de/Register';
import SingleProductDe from './components/de/SingleProduct';
import CartDe from './components/de/Cart';
import OrderSummaryDe from './components/de/OrderSummary';
import ReviewOrderDe from './components/de/ReviewOrder';
import PasswordResetDe from './components/de/ForgetPassword';
import PasswordResetConfirmDe from './components/de/PasswordReset';
import ProductsDe from './components/de/Products';
import NewCheckoutDe from './components/de/NewCheckout';
import PrivacyPolicyDe from './components/de/PrivacyPolicyDe';
import ContactDe from './components/de/ContactDe';
import JobsDe from './components/de/JobsDe';
import EventBookingDe from './components/de/EventBooking';
import UserDashDe from './components/de/userDash';


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

// Language detection
const language = localStorage.getItem('language') || 'en';

// Conditionally assign components
const C = language === 'de' ? {
  Header: HeaderDe,
  Footer: FooterDe,
  Home: HomeDe,
  Legal: Legalde,
  About: Aboutde,
  Impressum: ImpressumDe,
  PrivacyPolicy: PrivacyPolicyDe,
  Contact: ContactDe,
  Jobs: JobsDe,
  ProductDetail: ProductDetailDe,
  CategoryList: CategoryListDe,
  CategoryDetail: CategoryDetailDe,
  ViewCart: ViewCartDe,
  Login: LoginDe,
  Register: RegisterDe,
  SingleProduct: SingleProductDe,
  Cart: CartDe,
  OrderSummary: OrderSummaryDe,
  ReviewOrder: ReviewOrderDe,
  PasswordReset: PasswordResetDe,
  PasswordResetConfirm: PasswordResetConfirmDe,
  Products: ProductsDe,
  NewCheckout: NewCheckoutDe,
  EventBooking: EventBookingDe,
  UserDash: UserDashDe
} : {
  Header,
  Footer,
  Home,
  Legal,
  About,
  Impressum,
  PrivacyPolicy,
  Contact,
  Jobs,
  ProductDetail,
  CategoryList,
  CategoryDetail,
  ViewCart,
  CheckoutForm,
  Login,
  Register,
  SingleProduct,
  UserDash,
  Cart,
  OrderSummary,
  ReviewOrder,
  PasswordReset,
  PasswordResetConfirm,
  Products,
  NewCheckout,
  EventBooking
};

function App() {
  const [authToken, setAuthToken] = useState(null);

  useEffect(() => {
    // Check if user has a stored token and set it
    const storedToken = localStorage.getItem("authToken");
    if (storedToken) {
      setAuthToken(storedToken);
    }
  }, []);

  return (
    <Router>
      <CartProvider>
      <EnsureAnonymousUser />

        <C.Header />
        <div className="app-content">
        <Routes>
          <Route path="/" element={<C.Home />} />
          <Route path="/products" element={<C.Products />} />
          <Route path="/product/:slug" element={<C.ProductDetail />} />
          <Route path="/categories" element={<C.CategoryList />} />
          <Route path="/categories/:id" element={<C.CategoryDetail />} />
          <Route path="/cart" element={<C.Cart />} />
          <Route path="/viewcart" element={<C.ViewCart />} />
          <Route path="/checkout" element={
            <Elements stripe={stripePromise}>
              <C.NewCheckout />
            </Elements>
          } />
          <Route path="/review-order" element={
            <Elements stripe={stripePromise}>
              <C.ReviewOrder />
            </Elements>
          } />
          <Route path="/ordersummary/:orderId" element={<C.OrderSummary />} />
          <Route path="/history" element={<C.UserDash />} />
          <Route path="/login" element={<C.Login setAuthToken={setAuthToken} />} />
          <Route path="/register" element={<C.Register />} />
          <Route path="/forgotpassword" element={<C.PasswordReset />} />
          <Route path="/reset-password" element={<C.PasswordResetConfirm />} />
          <Route path="/dashboard" element={<C.UserDash />} />
          <Route path="/legal" element={<C.Legal />} />
          <Route path="/impressum" element={<C.Impressum />} />
          <Route path="/about-us" element={<C.About />} />
          <Route path="/privacy-policy" element={<C.PrivacyPolicy />} />
          <Route path="/policies/privacy-policy" element={<C.PrivacyPolicy />} />
          <Route path="/contact" element={<C.Contact />} />
          <Route path="/jobs" element={<C.Jobs />} />
          <Route path="/event-booking" element={<C.EventBooking />} />


        </Routes>
        </div>
        <C.Footer />
        <CookieConsent />
      </CartProvider>
    </Router>
  );
}

export default App;
